<div id="app-home">
  <!-- Actual Content -->
  <div id="app-home-inner-content">
    <div id="offline-watermark" *ngIf="!online">
      <mat-icon>signal_cellular_connected_no_internet_4_bar</mat-icon>
      <span>Offline Or Slow Internet Speeds.</span>
      <span>Some features may not be available.</span>
    </div>
    <div id="home-header" *ngIf="!isDesktop">
      <div class="non-title-container">
        <button
          id="menu-button"
          (click)="sideNavigatorService.toggleSideNavigator()"
        >
          <img src="assets/redesign/home/menu-icon.svg" alt="Menu" />
        </button>
      </div>
      <div id="home-title" class="large-title">Medic Now</div>
      <div id="home-logo">
        <img
          id="home-logo-img"
          [src]="organizationLogoUrl | safeUrl"
          alt="Logo"
        />
      </div>
    </div>
    <div id="desktop-home-header-container" *ngIf="isDesktop">
      <div id="desktop-home-header" *ngIf="isDesktop">
        <div id="header-mask"></div>
        <div id="header-name-and-org">
          <span>Welcome {{ firstName }}</span>
        </div>
        <div id="header-spacer"></div>
        <div id="header-badge">
          <img
            id="home-logo-img-desktop"
            [src]="organizationLogoUrl | safeUrl"
            alt="Logo"
          />
        </div>
      </div>
    </div>
    <div id="home-body">
      <!-- Skeleton Loader -->
      <div *ngIf="isLoading" class="skeleton-loader">
        <div class="skeleton-content">
          <div
            class="skeleton-feature"
            *ngFor="let _ of [1, 2, 3, 4, 5, 6, 7, 8]"
          ></div>
        </div>
      </div>
      <div id="feature-scrollable-container" *ngIf="!isLoading">
        <div id="feature-container">
          <div
            *ngFor="let feature of filterFeaturesForScreenSize()"
            class="feature-tile"
            (click)="
              navigateToFeature(
                feature.feature_id,
                feature.defaultPath,
                feature.defaultRoute
              )
            "
            clickable
          >
            <div class="item-wrapper">
              <div class="item-icon-container">
                <img
                  [src]="getIcon(feature) | safeUrl"
                  [alt]="feature.homeName"
                  (error)="onImageError()"
                />
              </div>
              <p class="item-text">{{ feature.homeName }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div id="spacer"></div>
    <app-footer id="app-footer" *ngIf="!isDesktop"></app-footer>
  </div>
</div>
